import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25.39 25.39A32.11 32.11 0 0 1 48 16v16c-4.48 0-8.32 1.7-11.3 4.7L25.38 25.38Z",
      fill: "#F73BA0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M36.7 36.7A15.62 15.62 0 0 0 32 48c0 4.48 1.7 8.32 4.7 11.3A15.62 15.62 0 0 0 48 64v16a32.11 32.11 0 0 1-22.61-9.39A32.11 32.11 0 0 1 16 48c0-8.75 3.63-16.85 9.39-22.61l11.3 11.3Z",
      fill: "#446CFC"
    }, null, -1),
    _createElementVNode("path", {
      d: "M48 32c4.48 0 8.32 1.7 11.3 4.7A15.62 15.62 0 0 1 64 48h16c0-8.75-3.63-16.85-9.39-22.61A32.11 32.11 0 0 0 48 16v16ZM80 64H64v16h16V64Z",
      fill: "#151F6D"
    }, null, -1)
  ])))
}
export default { render: render }